// Features.jsx
import CommunitySection from "./Features/CommunitySection";
import CampaignsSection from "./Features/CampaignsSection";
import InteractionsSection from "./Features/InteractionsSection";
import HeroSection from "./Features/HeroSection";

const Features = () => {
  return (
    <>
      <HeroSection />
      <CommunitySection />
      <CampaignsSection />
      <InteractionsSection />
    </>
  );
};

export default Features;
